import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getCompanyCodeDetails,
  getDILocationDetails,
  getDiAdherence,
  getDiAdherenceReport,
  getDiAdherenceTotal,
} from "../api/di";
import { downloadReportForS3Link } from "../api/downloadFile";
import axios from "axios";

export const fetchDiAdherence = createAsyncThunk(
  "di/fetchDiAdherence",
  async (params) =>
    getDiAdherence(
      params?.aggr,
      params?.startDate,
      params?.endDate,
      params?.division,
      params?.department,
      params?.vendor,
      params?.companyCodes,
      params?.diLocations,
      params?.page,
      params?.limit,
      params?.sort
    ).then((res) => res)
);

export const fetchDiAdherenceReport = createAsyncThunk(
  "di/fetchDiAdherenceReport",
  async (params) =>
    getDiAdherenceReport(
      params?.startDate,
      params?.endDate,
      params?.division,
      params?.department,
      params?.vendor,
      params?.companyCodes,
      params?.diLocations,
      params?.requestId
    )
      .then((res) => res)
      .catch((err) => err)
);

export const fetchCompanyCodeDetails = createAsyncThunk(
  "di/fetchCompanyCodeDetails",
  async () => getCompanyCodeDetails().then((res) => res)
);

export const fetchDILocationDetails = createAsyncThunk(
  "di/fetchDILocationDetails",
  async () => getDILocationDetails().then((res) => res)
);

export const fetchDiAdherenceTotal = createAsyncThunk(
  "di/fetchDiAdherenceTotal",
  async (params) =>
    getDiAdherenceTotal(
      params?.startDate,
      params?.endDate,
      params?.division,
      params?.department,
      params?.vendor,
      params?.companyCodes,
      params?.diLocations
    ).then((res) => res)
);

export const fetchDownloadReportS3Link = createAsyncThunk(
  "di/fetchDownloadReportS3Link",
  async (params) =>
    downloadReportForS3Link(params?.requestId).then((res) => res)
);

export const diSlice = createSlice({
  name: "di",
  initialState: {
    diAdherence: null,
    diAdherenceReport: null,
    companyCodeLocationDetails: null,
    diLocationDetails: null,
    loading: false,
    diAdherenceTotal: null,
    diReportError: false,
    diDownloadFileResponse: null,
  },
  reducers: {
    resetDiReportError: (state, { payload }) => {
      state.diReportError = false;
    },
    resetDiDownloadFileResponse: (state, { payload }) => {
      state.diDownloadFileResponse = false;
    },
  },
  extraReducers: {
    [fetchDiAdherence.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchDiAdherence.fulfilled]: (state, { payload }) => {
      state.diAdherence = payload;
      state.loading = false;
    },
    [fetchDiAdherence.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [fetchDiAdherenceReport.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [fetchDiAdherenceReport.fulfilled]: (state, { payload }) => {
      if (axios.isAxiosError(payload)) state.diReportError = true;
      else {
        state.diReportError = false;
        state.diAdherenceReport = payload;
      }
      state.loading = false;
    },
    [fetchDiAdherenceReport.rejected]: (state, { payload }) => {
      state.diReportError = true;
      state.loading = false;
    },
    [fetchCompanyCodeDetails.fulfilled]: (state, { payload }) => {
      state.companyCodeLocationDetails = payload;
    },
    [fetchDILocationDetails.fulfilled]: (state, { payload }) => {
      state.diLocationDetails = payload;
    },
    [fetchDiAdherenceTotal.fulfilled]: (state, { payload }) => {
      state.diAdherenceTotal = payload;
    },
    [fetchDownloadReportS3Link.fulfilled]: (state, { payload }) => {
      state.diDownloadFileResponse = payload;
    },
  },
});

export default diSlice.reducer;
export const { resetDiReportError, resetDiDownloadFileResponse } = diSlice.actions;
